<template>
  <div class="preview-component">
    <div :style="{'opacity': view === 'mobile' ? 1 : 0}" class="fanfrick-mobile-page-preview-box">
      <div class="mobile-box">
        <img :class="[ view === 'mobile' ]" class="background" src="@/assets/gate-preview/iphone_14.svg" alt="Iphone view"/>
        <div class="mobile-image-box">
          <div class="image-wrapper">
            <div class="preview active"></div>
            <img v-if="page.cover" :src="page.cover" alt="">
            <div class="radius-block">
              <img src="@/assets/gate-preview/radius-image.svg" alt="">
            </div>
          </div>
          <div class="mobile-content">
            <div class="title">
              <h2>{{page.title ? page.title : 'Campaign title'}}</h2>
            </div>
            <div class="description">
              <p>{{page.description ? page.description : 'Campaign description'}}</p>
            </div>
            <div v-if="!!page.steps" class="social-button-box">
              <div class="social-button mobile">
                <button v-for="input in page.steps.find(v => v.status)?.check.inputs"
                        class="btn-uns"
                        :class="{
                              'fb-button': $route.params.social === 'facebook',
                              'inst-button': $route.params.social === 'instagram',
                              'youtube-button': $route.params.social === 'youtube',
                              'tiktok-button': $route.params.social === 'tiktok',
                              'linkedin-button': $route.params.social === 'linkedin'
                            }"
                        :disabled="true">
                  <img v-if="$route.params.social === 'youtube'"
                       src="../../assets/yotube.svg" alt="">
                  <img v-if="$route.params.social === 'instagram'" src="../../assets/inst-white.svg"
                       alt="">
                  <img v-if="$route.params.social === 'facebook'" src="../../assets/icn-facebook.svg"
                       alt="">
                  <img v-if="$route.params.social === 'twitter'" src="../../assets/twitter-white.svg"
                       alt="">
                  <img v-if="$route.params.social === 'tiktok'" src="../../assets/tiktok-logo-white.svg"
                       alt="">
                  <img v-if="$route.params.social === 'linkedin'"
                       src="../../assets/linkedin-logo-white.svg" alt="">
                  <img v-if="$route.params.social === 'telegram_channel'"
                       src="../../assets/telegram-white.svg" alt="">
                  <span>{{input.action}} {{input.button ? input.button : 'on ' + page.steps.find(v => v.status)?.name.replace('_', ' ') === 'Twitter' ? 'X (Twitter)' : page.steps.find(v => v.status)?.name.replace('_', ' ')}}</span>
                </button>
              </div>
            </div>
            <div class="social-input-box">
              <div class="social-input mobile">
                <CustomInput type="text" name="text" :placeholder="createPlaceholder(page.steps.find(v => v.status)?.name)" :dis="true"/>
              </div>
            </div>
            <div class="reward-button-box">
              <div class="reward-button mobile">
                <button class="blue-btn sm normal show-reward-btn text-btn-campaign">
                  Show reward
                </button>
              </div>
            </div>
            <div v-if="page.steps.find(v => v.status)?.check.skippable >= 1" class="skip-block">
              <a>Click to skip
                <span v-if="page.steps.find(v => v.status)?.check.skippable > 1">
                  ({{page.steps.find(v => v.status)?.check.skippable + 's'}})
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div :style="{'opacity': view === 'laptop' ? 1 : 0}" class="preview-box tapmixer-page-preview-box">
      <div class="content">
        <div class="logo">
          <img class="desktop-on-view" alt="logo" src="../../assets/new-home/icons/fanfrick-logo.svg" />
        </div>
        <div class="campaign-content">
          <div class="title">
            <h2>{{page.title ? page.title : 'Campaign title'}}</h2>
          </div>
          <div class="description">
            <p>{{page.description ? page.description : 'Campaign description'}}</p>
          </div>
          <div class="social-button">
            <button v-for="input in page.steps.find(v => v.status)?.check.inputs"
                class="btn-uns"
                    :class="{
                              'fb-button': $route.params.social === 'facebook',
                              'inst-button': $route.params.social === 'instagram',
                              'youtube-button': $route.params.social === 'youtube',
                              'tiktok-button': $route.params.social === 'tiktok',
                              'linkedin-button': $route.params.social === 'linkedin'
                            }"
                    :disabled="true">
              <img v-if="$route.params.social === 'youtube'"
                   src="../../assets/yotube.svg" alt="">
              <img v-if="$route.params.social === 'instagram'" src="../../assets/inst-white.svg"
                   alt="">
              <img v-if="$route.params.social === 'facebook'" src="../../assets/icn-facebook.svg"
                   alt="">
              <img v-if="$route.params.social === 'twitter'" src="../../assets/twitter-white.svg"
                   alt="">
              <img v-if="$route.params.social === 'tiktok'" src="../../assets/tiktok-logo-white.svg"
                   alt="">
              <img v-if="$route.params.social === 'linkedin'"
                   src="../../assets/linkedin-logo-white.svg" alt="">
              <img v-if="$route.params.social === 'telegram_channel'"
                   src="../../assets/telegram-white.svg" alt="">
              <span>{{input.action}} {{input.button ? input.button : 'on ' + (page.steps.find(v => v.status)?.name.replace('_', ' ') === 'Twitter' ? 'X (Twitter)' : page.steps.find(v => v.status)?.name.replace('_', ' '))}}</span>
            </button>
          </div>
          <div class="social-input">
            <CustomInput type="text" name="text" :placeholder="createPlaceholder(page.steps.find(v => v.status)?.name)" :dis="true"/>
          </div>
          <div class="reward-button">
            <button class="blue-btn sm normal show-reward-btn text-btn-campaign">
              Show reward
            </button>
          </div>
          <div class="skip-link">
            <a v-if="page.steps.find(v => v.status)?.check.skippable >= 1">Click to skip
              <span v-if="page.steps.find(v => v.status)?.check.skippable > 1">
                  ({{page.steps.find(v => v.status)?.check.skippable + 's'}})
                </span>
            </a>
          </div>
        </div>
      </div>
      <div class="image">
        <div class="preview active"></div>
        <img v-if="page.cover" :src="page.cover" alt="">
        <div class="vertical-radius-block">
          <img src="@/assets/gate-preview/vertical-radius.svg" alt="">
        </div>
      </div>
    </div>
<!--    <div class="preview-box fanfrick-page-preview-box">-->
<!--      <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad, blanditiis?</p>-->
<!--    </div>-->
  </div>
</template>
<script>
import CustomInput from "../CustomInput/CustomInput.vue";
import Preloader from "../Preloader/Preloader.vue";
import Vue from "vue";
export default Vue.extend({
  name: 'Preview',
  components: {
    CustomInput,
    Preloader
  },
  data() {
    return {
      preloading: false
    }
  },
  props: {
    page: {
      type: Object
    },
    view: {
      type: String
    }
  },
  watch: {
    image(newImage) {
      localStorage.image = newImage;
    },
  },
  methods: {
    createPlaceholder(name) {
      switch (name) {
        case 'E-mail capture':
          return 'Enter your email';
        case 'SMS':
          return 'Enter your phone (start with +)';
        case 'Telegram':
          return `Enter code from ${name} App`;
        case 'Telegram_channel':
          return `Enter your telegram profile link`;
        default:
          return `Enter your ${name} profile link`;
      }
    },
  }
})
</script>
<style lang="scss">;
.preview-component {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  margin: auto;

  .fanfrick-mobile-page-preview-box {
    margin: auto;
    width: 390px;
    height: 844px;
    position: absolute;
    @media (max-width: 1921px) {
      width: 360px;
      height: 777px;
    }
    @media (max-width: 1441px) {
      width: 320px;
      height: 691px;
    }
    @media (max-width: 1367px) {
      width: 300px;
      height: 648px;
    }
    .mobile-box {
      position: relative;
      height: 100%;
      width: 100%;
      border-radius: 50px;
      overflow: hidden;
      @media (max-width: 1441px) {
        border-radius: 40px;
      }
      img.background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10003;
      }
      .mobile-image-box {
        width: 384px;
        height: 838px;
        margin-left: 3px;
        margin-top: 3px;
        border-radius: 46px;
        overflow: hidden;
        position: relative;
        @media (max-width: 1921px) {
          width: 354px;
          height: 771px;
        }
        @media (max-width: 1441px) {
          width: 314px;
          height: 685px;
          border-radius: 40px;
        }
        @media (max-width: 1367px) {
          width: 294px;
          height: 679px;
          border-radius: 40px;
        }
        .image-wrapper {
          position: relative;
          overflow: hidden;
          width: 384px;
          height: 384px;
          object-fit: cover;
          @media (max-width: 1921px) {
            width: 354px;
            height: 354px;
          }
          @media (max-width: 1441px) {
            width: 314px;
            height: 314px;
          }
          @media (max-width: 1367px) {
            width: 294px;
          }
          img {
            width: 100%;
          }
          .preview {
            width: 100% !important;
            height: 100% !important;
            border: 1px solid #ffffff;
          }
          .radius-block {
            position: absolute;
            left: 0;
            bottom: -1px;
            z-index: 10002;
            img {
              width: 100%;
            }
          }
        }
        .mobile-image {
          overflow: hidden;
          position: relative;
          img {
            width: 100%;
          }
        }
        .mobile-content {
          padding: 0 20px;
          height: 100%;
          display: flex;
          flex-direction: column;
          @media (max-width: 1921px) {
            height: calc(771px - 354px);
          }
          @media (max-width: 1441px) {
            height: calc(771px - 314px);
          }
          @media (max-width: 768px) {
            height: calc(771px - 444px);
          }
          .title {
            margin-top: 30px;
            h2 {
              font-family: "Amatic SC", sans-serif;
              text-align: center;
              font-size: 30px;
              line-height: 33px;
              font-weight: 700;
            }
          }
          .description {
            margin-top: 30px;
            p {
              font-family: "Levenim MT", sans-serif;
              text-align: center;
              font-size: 11px;
              line-height: 16px;
            }
            @media (max-width: 768px) {
              margin-top: 10px;
            }
          }
          .social-button-box {}
          .reward-button-box {}
          .skip-block {
            margin-top: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 0 10px 0;
            a {
              font-size: 12px;
            }
          }
        }
      }
    }
  }

  .preview-box {
    width: 1100px;
    height: 545px;
    overflow: hidden;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin: auto;
    position: absolute;
    @media (max-width: 2530px) {
      width: 760px;
      height: 377px;
    }
    @media (max-width: 1921px) {
      width: 760px;
      height: 377px;
    }

    @media (max-width: 1810px) {
      width: 580px;
      height: 292px;
    }
    @media (max-width: 1365px) {
      position: relative;
    }
    @media (max-width: 1441px) {
      width: 580px;
      height: 292px;
    }
    @media (max-width: 768px) {
      width: 350px;
      height: 175px;
      position: relative;
    }
    .image {
      width: 545px !important;
      height: 545px !important;
      position: relative;
      object-fit: cover;
      overflow: hidden;
      .vertical-radius-block {
        position: absolute;
        left: -1px;
        top: -1px;
        height: calc(100% + 6px);
        img {
          height: 100%;
          width: 100%;
        }
      }
      @media (max-width: 2530px) {
        width: 397px!important;
        height: 397px!important;
      }
      @media (max-width: 1921px) {
        width: 377px!important;
        height: 377px!important;
      }
      @media (max-width: 1810px) {
        width: 292px!important;
        height: 292px!important;
      }
      @media (max-width: 1441px) {
        width: 292px!important;
        height: 292px!important;
      }
      @media (max-width: 768px) {
        width: 177px!important;
        height: 177px!important;
      }
      .preview {
        width: 100%!important;
        height: 100%!important;
        img {
          // object-fit: cover;
        }
      }
    }
    .content {
      width: 50%;
      height: 100%;
      padding: 0 5%;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      @media (max-width: 768px) {
        padding: 0 10%;
      }
      .logo {
        max-width: 50px;
        // margin-bottom: auto;
        margin-top: 20px;
        @media (max-width: 1367px) {
          max-width: 40px;
        }
        @media (max-width: 768px) {
          margin-top: 20px;
          max-width: 20px;
          justify-content: flex-start;
        }
        img {
          width: 100%;
        }
      }
      .campaign-content {
        margin-top: 70px;
        width: 100%;
        @media (max-width: 1921px) {
          margin-top: 40px;
        }
        @media (max-width: 1441px) {
          margin-top: 30px;
        }
        @media (max-width: 1367px) {
          margin-top: 15px;
        }
        @media (max-width: 768px) {
          margin-top: 10px;
        }
        .title {
          margin-top: 10px;
          h2 {
            font-family: "Amatic SC", sans-serif;
            font-size: 32px;
            font-weight: 600;
          }
          @media (max-width: 1920px) {
            margin-top: 10px;
            h2 {
              font-family: "Amatic SC", sans-serif;
              font-size: 22px;
              font-weight: 600;
            }
          }
          @media (max-width: 1441px) {
            margin-top: 10px;
            h2 {
              font-family: "Amatic SC", sans-serif;
              font-size: 20px;
              font-weight: 600;
            }
          }
          @media (max-width: 1367px) {
            margin-top: 10px;
            h2 {
              font-family: "Amatic SC", sans-serif;
              font-size: 18px;
              font-weight: 600;
            }
          }
          @media (max-width: 768px) {
            margin-top: 6px;
            h2 {
              font-family: "Amatic SC", sans-serif;
              font-size: 12px;
              font-weight: 600;
            }
          }
        }
        .description {
          margin-top: 10px;
          p {
            font-family: "Levenim MT", sans-serif;
            font-size: 11px;
            line-height: 13px;
          }
          @media (max-width: 1921px) {
            margin-top: 10px;
            p {
              font-family: "Levenim MT", sans-serif;
              font-size: 9px;
              line-height: 11px;
            }
          }
          @media (max-width: 1441px) {
            margin-top: 10px;
            p {
              font-family: "Levenim MT", sans-serif;
              font-size: 8px;
            }
          }
          @media (max-width: 1367px) {
            margin-top: 10px;
            p {
              font-family: "Levenim MT", sans-serif;
              font-size: 7px;
            }
          }
          @media (max-width: 768px) {
            margin-top: 5px;
            p {
              font-family: "Levenim MT", sans-serif;
              font-size: 3px;
              line-height: 4px;
            }
          }
        }
        .skip-link {
          margin-top: auto;
          //padding: 110px 0 0 0;
          display: flex;
          align-items: flex-end;
          height: 56px;
          a {
            width: 100%;
            text-align: center;
            font-size: 10px;
          }
          @media (max-width: 1921px) {
            //padding: 50px 0 0 0;
          }
          @media (max-width: 1810px) {
            //padding: 50px 0 0 0;
            height: 40px;
          }
          @media (max-width: 1441px) {
            //padding: 30px 0 0 0;
          }
          @media (max-width: 768px) {
            //padding: 15px 0 0 0;
            a {
              font-size: 7px;
            }
          }
        }
      }
    }
  }
}
.social-button {
  .btn-uns {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 35px;
    font-size: 0.75rem;
    transition: 0.5s;
    margin-top: 10px;
    margin-bottom: 10px;
    background: #279AEA;
    border-radius: 6px;
    img {
      height: 16px;
      width: auto;
    }
    span {
      color: #ffffff;
      margin: 0 0 0 5px;
    }
  }
  @media (max-width: 1921px) {
    .btn-uns {
      height: 30px;
      font-size: 0.65rem;
      transition: 0.5s;
      img {
        height: 12px;
        width: auto;
      }
      span {
        color: #ffffff;
        margin: 0 0 0 5px;
      }
    }
  }
  @media (max-width: 1441px) {
    .btn-uns {
      height: 26px;
      font-size: 0.6rem;
      transition: 0.5s;
      img {
        height: 12px;
        width: auto;
      }
      span {
        color: #ffffff;
        margin: 0 0 0 5px;
      }
    }
  }
  @media (max-width: 1367px) {
    .btn-uns {
      height: 24px;
      font-size: 0.6rem;
      transition: 0.5s;
      img {
        height: 12px;
        width: auto;
      }
      span {
        color: #ffffff;
        margin: 0 0 0 5px;
      }
    }
  }
  @media (max-width: 768px) {
    .btn-uns {
      height: 8px;
      font-size: 3px;
      transition: 0.5s;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      img {
        height: 4px;
        width: auto;
      }
      span {
        color: #ffffff;
        margin: 3px 0 0 3px;
      }
    }
  }
}

.social-button.mobile {
  .btn-uns {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 35px;
    font-size: 0.75rem;
    transition: 0.5s;
    margin-top: 10px;
    margin-bottom: 10px;
    background: #279AEA;
    border-radius: 6px;
    img {
      height: 16px;
      width: auto;
    }
    span {
      color: #ffffff;
      margin: 0 0 0 5px;
    }
  }
  @media (max-width: 1921px) {
    .btn-uns {
      height: 30px;
      font-size: 0.65rem;
      transition: 0.5s;
      img {
        height: 12px;
        width: auto;
      }
      span {
        color: #ffffff;
        margin: 0 0 0 5px;
      }
    }
  }
  @media (max-width: 1441px) {
    .btn-uns {
      height: 26px;
      font-size: 0.6rem;
      transition: 0.5s;
      img {
        height: 12px;
        width: auto;
      }
      span {
        color: #ffffff;
        margin: 0 0 0 5px;
      }
    }
  }
  @media (max-width: 1367px) {
    .btn-uns {
      height: 24px;
      font-size: 0.6rem;
      transition: 0.5s;
      img {
        height: 12px;
        width: auto;
      }
      span {
        color: #ffffff;
        margin: 0 0 0 5px;
      }
    }
  }
}

.social-input {
  font-size: 12px;
  .inp {
    input {}
  }
  @media (max-width: 1921px) {
    font-size: 10px;
    .inp {
      height: 28px;
      input {
        height: 28px;
      }
    }
  }
  @media (max-width: 1441px) {
    font-size: 9px;
    .inp {
      height: 22px;
      input {
        height: 24px;
      }
    }
  }
  @media (max-width: 768px) {
    font-size: 3px;
    .inp {
      height: 8px;
      input {
        height: 8px;
      }
    }
  }
}

.social-input.mobile {
  font-size: 12px;
  .inp {
    input {}
  }
  @media (max-width: 1921px) {
    font-size: 10px;
    .inp {
      height: 28px;
      input {
        height: 28px;
      }
    }
  }
  @media (max-width: 1441px) {
    font-size: 9px;
    .inp {
      height: 22px;
      input {
        height: 24px;
      }
    }
  }
  //@media (max-width: 768px) {
  //  font-size: 3px;
  //  .inp {
  //    height: 8px;
  //    input {
  //      height: 8px;
  //    }
  //  }
  //}
}

.reward-button {
  width: 100%;
  margin-top: 8px;
  button {
    font-size: 12px;
    text-transform: uppercase;
    width: 100%;
    height: 35px!important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media (max-width: 1921px) {
    width: 100%;
    margin-top: 8px;
    button {
      font-size: 8px;
      text-transform: uppercase;
      width: 100%;
      height: 30px!important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  @media (max-width: 1441px) {
    width: 100%;
    margin-top: 8px;
    button {
      font-size: 8px;
      text-transform: uppercase;
      width: 100%;
      height: 26px!important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  @media (max-width: 1367px) {
    width: 100%;
    margin-top: 8px;
    button {
      font-size: 8px;
      text-transform: uppercase;
      width: 100%;
      height: 24px!important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  @media (max-width: 768px) {
    width: 100%;
    margin-top: 5px;
    button {
      border-radius: 2px;
      font-size: 3px;
      text-transform: uppercase;
      width: 100%;
      height: 8px!important;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px 20px!important;
    }
  }
}
.reward-button.mobile {
  width: 100%;
  margin-top: 8px;
  button {
    font-size: 12px;
    text-transform: uppercase;
    width: 100%;
    height: 35px!important;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media (max-width: 1921px) {
    width: 100%;
    margin-top: 8px;
    button {
      font-size: 8px;
      text-transform: uppercase;
      width: 100%;
      height: 30px!important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  @media (max-width: 1441px) {
    width: 100%;
    margin-top: 8px;
    button {
      font-size: 8px;
      text-transform: uppercase;
      width: 100%;
      height: 26px!important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  @media (max-width: 1367px) {
    width: 100%;
    margin-top: 8px;
    button {
      font-size: 8px;
      text-transform: uppercase;
      width: 100%;
      height: 24px!important;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>